import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  standalone: false,
  name: 'bringozMetaDataDisplay'
})
export class BringozMetaDataDisplayPipe implements PipeTransform {
  transform(entityMetaDataList: any[], selectedMetaData: any): string {
    if (!entityMetaDataList) {
      entityMetaDataList = [];
    }

    const metaDataFound = _.find(entityMetaDataList.slice().reverse(), m => _.get(m, 'key') === _.get(selectedMetaData, 'key', false));

    return _.get(metaDataFound, 'value', '---');
  }
}
